import React from "react";
import { Button } from "../../primary";
import { CANCEL_BTN, SAVE_BTN, CANCEL_ID, SUBMIT_ID } from "../../../constants";
import styles from "./assign.module.scss";

const FormFooter = ({ show, onCancel }) => {
  if (!show) return null;

  return (
    <div className="col-sm-12 text-center pb-4">
      <Button classes={{ className: `btn ${styles.btn_custom} ${styles.btn_small}` }} type="submit" id={SUBMIT_ID}>
        {SAVE_BTN}
      </Button>

      <Button
        classes={{
          className: `btn mr-3 ${styles.btn_custom} ${styles.btn_small_cancel}`,
        }}
        id={CANCEL_ID}
        type="button"
        onClick={onCancel}
      >
        {CANCEL_BTN}
      </Button>
    </div>
  );
};

export default FormFooter;
